export const defaultRoles = [
  {
    name: 'Verkoop Buiten',
  },
  {
    name: 'Verkoop Binnen',
  },
  {
    name: 'Calculator',
  },
  {
    name: 'Projectmanager',
  },
  {
    name: 'Projectengineer',
  },
  {
    name: 'Projectleider',
  },
  {
    name: 'Werkvoorbereider',
  },
  {
    name: 'Tekenaar',
  },
  {
    name: 'Uitvoerder',
  },
  {
    name: 'Voorman',
  },
  {
    name: 'Halleider',
  },
  {
    name: 'Interne Kwaliteitsborger',
  },
  {
    name: 'Externe Kwaliteitsborger',
  },
  {
    name: 'Productie Planner',
  },
];

export const defaultModules = [
  {
    name: 'Project Gantt',
  },
  {
    name: 'Manual Import',
  },
  {
    name: 'Project assembly planning',
  },
  {
    name: 'Bill of Material',
  },
  {
    name: 'Assembly Preparations',
  },
  {
    name: 'Module Assembly',
  },
  {
    name: 'Quality Control',
  },
  {
    name: 'Risico Analyse',
  },
  {
    name: 'Keuringsplan',
  },
  {
    name: 'Phase Transfer',
  },
  {
    name: 'Advanced Model Import',
  },
];

export const rolesToModulesMapping = [
  {
    role: 'Verkoop Buiten',
    modules: ['Quality Control'],
    tables: ['CFFA_DHME_WKB_ANALYSIS', 'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES'],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Verkoop Binnen',
    modules: ['Quality Control'],
    tables: ['CFFA_DHME_WKB_ANALYSIS', 'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES'],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Calculator',
    modules: ['Bill of Material', 'Quality Control'],
    tables: [
      'CFFA_DHME_ELEMENTS',
      'CFFA_DHME_MODEL_MAPPING',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_NON_MODULES',
      'CFFA_DHME_OBJECTS',
      'CFFA_DHME_RESOURCEGROUP_ELEMENTS',
      'CFFA_DHME_RESOURCEGROUP_OBJECTS',
      'CFFA_DHME_RESOURCEGROUPS',
      'CFFA_FORGE_CLIENT',
      'CFFA_FORGE_MODELS',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Projectengineer',
    modules: [
      'Project Gantt',
      'Risico Analyse',
      'Keuringsplan',
      'Phase Transfer',
      'Quality Control',
    ],
    tables: [
      'CFFA_DHME_MODULES',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_CHAPTER_STATUSES',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATION_DOCS',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATIONS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Projectmanager',
    modules: [
      'Project Gantt',
      'Risico Analyse',
      'Keuringsplan',
      'Phase Transfer',
      'Quality Control',
    ],
    tables: [
      'CFFA_DHME_MODULES',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_CHAPTER_STATUSES',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATION_DOCS',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATIONS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Projectleider',
    modules: [
      'Project Gantt',
      'Quality Control',
      'Phase Transfer',
      'Manual Import',
      'Project assembly planning',
      'Bill of Material',
      'Advanced Model Import',
    ],
    tables: [
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_FORGE_CLIENT',
      'CFFA_FORGE_MODELS',
      'CFFA_DHME_OBJECTS',
      'CFFA_DHME_ELEMENTS',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_NON_MODULES',
      'CFFA_DHME_MODEL_MAPPING',
      'CFFA_DHME_DRAWINGS',
      'CFFA_DHME_ELEMENT_CONTENTS',
      'CFFA_DHME_MANUAL_IMPORT_GENERATIONS',
      'CFFA_DHME_MODULE_CONTENTS',
      'CFFA_DHME_MODULE',
      'CFFA_DHME_OBJECTS_REGISTER',
      'CFFA_DHME_RESOURCEGROUP_ELEMENTS',
      'CFFA_DHME_RESOURCEGROUP_OBJECTS',
      'CFFA_DHME_RESOURCEGROUPS',
      'CFFA_DHME_ASSEMBLY_PREPARATIONS_STATUS',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Werkvoorbereider',
    modules: [
      'Project Gantt',
      'Manual Import',
      'Project assembly planning',
      'Bill of Material',
      'Quality Control',
      'Phase Transfer',
      'Advanced Model Import',
    ],
    tables: [
      'CFFA_DHME_ELEMENTS',
      'CFFA_DHME_ELEMENT_CONTENTS',
      'CFFA_DHME_MANUAL_IMPORT_GENERATIONS',
      'CFFA_DHME_MODULE_CONTENTS',
      'CFFA_DHME_MODULE',
      'CFFA_DHME_NON_MODULES',
      'CFFA_DHME_OBJECTS',
      'CFFA_DHME_OBJECTS_REGISTER',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_MODEL_MAPPING',
      'CFFA_DHME_RESOURCEGROUP_ELEMENTS',
      'CFFA_DHME_RESOURCEGROUP_OBJECTS',
      'CFFA_DHME_RESOURCEGROUPS',
      'CFFA_FORGE_CLIENT',
      'CFFA_FORGE_MODELS',
      'CFFA_DHME_ASSEMBLY_PREPARATIONS_STATUS',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_DHME_DRAWINGS',
    ],
    general_permissions: ['tasks', 'sbs'],
    sbs_permissions: ['create', 'update', 'delete'],
    autoAdd: false,
  },
  {
    role: 'Tekenaar',
    modules: ['Quality Control'],
    tables: [
      'CFFA_FORGE_CLIENT',
      'CFFA_FORGE_MODELS',
      'CFFA_DHME_OBJECTS',
      'CFFA_DHME_ELEMENTS',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_NON_MODULES',
      'CFFA_DHME_MODEL_MAPPING',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_DHME_DRAWINGS',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Uitvoerder',
    modules: ['Quality Control', 'Phase Transfer'],
    tables: ['CFFA_DHME_WKB_ANALYSIS', 'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES'],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Voorman',
    modules: ['Quality Control'],
    tables: ['CFFA_DHME_WKB_ANALYSIS', 'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES'],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Halleider',
    modules: [
      'Quality Control',
      'Phase Transfer',
      'Assembly Preparations',
      'Module Assembly',
      'Project assembly planning',
    ],
    tables: [
      'CFFA_DHME_MODULES',
      'CFFA_DHME_DRAWINGS',
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_DHME_ASSEMBLY_PREPARATIONS_STATUS',
      'CFFA_DHME_ELEMENTS',
      'CFFA_DHME_ELEMENTS_SEQUENCE',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Interne Kwaliteitsborger',
    modules: ['Quality Control', 'Keuringsplan', 'Risico Analyse'],
    tables: [
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_WKB_CHAPTER_STATUSES',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATION_DOCS',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATIONS',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Externe Kwaliteitsborger',
    modules: ['Quality Control', 'Keuringsplan', 'Risico Analyse'],
    tables: [
      'CFFA_DHME_WKB_ANALYSIS',
      'CFFA_DHME_WKB_PROJECT_RISKS_MEASURES',
      'CFFA_DHME_MODULES',
      'CFFA_DHME_WKB_CHAPTER_STATUSES',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATION_DOCS',
      'CFFA_DHME_WKB_CHAPTER_SUBSTANTIATIONS',
    ],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
  {
    role: 'Productie Planner',
    modules: [],
    tables: ['CFFA_DHME_MODULES'],
    general_permissions: ['tasks'],
    autoAdd: false,
  },
];
